<section class="py-24">
  <div>
    <!-- Header -->
    <div class="flex justify-center mb-8" data-aos="fade-up">
      <span
        class="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-full px-3 py-1.5 text-sm font-medium text-[#061430]"
      >
        <app-icon name="svg:logo-white" [size]="20"/>
        {{ "recruiterProgram.services.badge" | translate }}
      </span>
    </div>
    <h2
      class="text-center text-[32px] md:text-[44px] lg:text-[52px] font-black leading-tight tracking-[-2px] text-[#000D4A] mb-20"
      data-aos="fade-up"
      data-aos-delay="50"
    >
      {{ "recruiterProgram.services.title" | translate }}
    </h2>

    <!-- Service rows -->
    <div
      *ngFor="let service of services; let odd = odd"
      class="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20 items-center mb-24 last:mb-0"
      data-aos="fade-up"
    >
      <!-- Text (DOM-first = start/right in RTL) -->
      <div class="flex flex-col gap-6" [class.md:order-2]="odd">
        <span
          class="inline-flex items-center gap-1.5 bg-[rgba(42,237,115,0.12)] text-[#2AED73] text-sm font-medium px-3 py-1.5 rounded-full w-fit"
        >
          <app-icon [name]="service.badgeIcon" [size]="20"/>
          {{ service.badgeKey | translate }}
        </span>

        <h3 class="text-3xl md:text-[40px] font-bold leading-[1.1] text-[#000d4a]">
          {{ service.titleKey | translate }}
        </h3>

        <p class="text-[17px] leading-[30px] text-[#525866]">
          {{ service.descKey | translate }}
        </p>

        <a
          [href]="getSignupUrl()"
          class="w-fit inline-flex items-center gap-2 bg-primary text-white rounded-full py-3 px-5 text-base font-semibold"
        >
          {{ "recruiterProgram.services.register" | translate }}

          <span class="rtl:flip inline-flex items-center">
            <app-icon name="tabler:arrow-narrow-right" [size]="20" class="text-white"/>
          </span>
        </a>
      </div>

      <!-- Image (DOM-second = end/left in RTL) -->
      <div [class.md:order-1]="odd">
        <app-responsive-img
          basePath="assets/images/recruiter-program"
          [langAware]="false"
          [name]="service.imageName"
          [alt]="service.titleKey | translate"
          loading="lazy"
          imgClass="w-full rounded-2xl object-contain"
          sizes="(min-width: 768px) 50vw, 100vw"
        />
      </div>
    </div>
  </div>
</section>
